import React from "react";
import MascotOrb from "./MascotOrb";
import { useBookDemo } from "@/contexts/BookDemoContext";

export default function FinalCTA() {
  const { openBookDemo } = useBookDemo();
  return (
    <section
      id="final-cta"
      data-testid="final-cta-section"
      className="relative min-h-screen flex items-center py-16 px-4 sm:px-6 lg:px-8"
    >
      <div
        className="relative max-w-6xl mx-auto w-full rounded-[32px] overflow-hidden border border-white/20"
        style={{
          background:
            "linear-gradient(135deg, #1e3a8a 0%, #3730a3 45%, #5b21b6 100%)",
          boxShadow:
            "0 50px 100px -40px rgba(30, 58, 138, 0.5), inset 0 1px 0 rgba(255,255,255,0.15)",
        }}
      >
        {/* Decorative orbs (slow-drifting for ambient motion) */}
        <div
          className="bg-orb bg-orb--a"
          style={{
            top: "-10%",
            left: "-10%",
            width: 380,
            height: 380,
            opacity: 0.5,
            background:
              "radial-gradient(circle, rgba(125,211,252,0.65), transparent 70%)",
            filter: "blur(70px)",
          }}
        />
        <div
          className="bg-orb bg-orb--b"
          style={{
            bottom: "-16%",
            right: "-8%",
            width: 440,
            height: 440,
            opacity: 0.5,
            background:
              "radial-gradient(circle, rgba(167,139,250,0.55), transparent 70%)",
            filter: "blur(75px)",
          }}
        />

        {/* Soft grid overlay */}
        <div
          className="absolute inset-0 opacity-10"
          style={{
            backgroundImage:
              "linear-gradient(rgba(255,255,255,0.35) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.35) 1px, transparent 1px)",
            backgroundSize: "56px 56px",
            maskImage:
              "radial-gradient(ellipse at center, black 40%, transparent 75%)",
            WebkitMaskImage:
              "radial-gradient(ellipse at center, black 40%, transparent 75%)",
          }}
        />

        <div className="relative grid lg:grid-cols-[1.3fr_1fr] gap-10 items-center p-10 sm:p-14 lg:p-16">
          <div>
            <div className="text-[11px] font-bold uppercase tracking-[0.22em] text-blue-200">
              Ready when you are
            </div>
            <h2 className="mt-3 text-[36px] sm:text-[46px] leading-[1.05] font-extrabold tracking-tight text-white text-balance">
              Turn your training content into AI learning experiences.
            </h2>
            <p className="mt-4 text-[16px] leading-relaxed text-blue-100 max-w-xl">
              From scattered files to guided sessions and trainer-ready
              insight—AI Trainer helps your team train better, faster.
            </p>

            <div className="mt-8 flex w-full flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:justify-start sm:gap-4">
              <button
                type="button"
                data-testid="final-cta-primary"
                onClick={() => openBookDemo()}
                className="btn-sheen inline-flex w-full shrink-0 items-center justify-center gap-2 text-[15px] font-semibold text-slate-900 bg-white px-6 py-3.5 rounded-full shadow-[0_12px_30px_-8px_rgba(255,255,255,0.35)] hover:-translate-y-0.5 transition-all sm:w-auto"
              >
                Book a demo
                <span className="text-slate-500">→</span>
              </button>
              <a
                href="#how-it-works"
                data-testid="final-cta-secondary"
                className="inline-flex w-full shrink-0 items-center justify-center gap-2 text-[15px] font-semibold text-white bg-white/10 backdrop-blur-md border border-white/30 px-5 py-3.5 rounded-full hover:bg-white/20 hover:-translate-y-0.5 transition-all sm:w-auto"
              >
                See product walkthrough
              </a>
            </div>

            <div className="mt-6 flex items-center gap-2 text-[12.5px] font-medium text-blue-200">
              <svg
                viewBox="0 0 20 20"
                fill="none"
                className="w-4 h-4 text-emerald-300"
              >
                <path
                  d="M5 10.5l3.2 3.2L15 7"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              No rebuild required. Start with the content you already have.
            </div>
          </div>

          <div className="relative hidden lg:flex items-center justify-center">
            <div className="absolute w-64 h-64 rounded-full bg-gradient-to-br from-blue-400/30 to-violet-400/30 blur-2xl" />
            <MascotOrb size={180} speaking />
          </div>
        </div>
      </div>
    </section>
  );
}
